import React from 'react'

export default function ListaLinhaValorDestacado(props) {

    return <>
        {props.destacado
            ? <><i className={`zmdi  zmdi-play`} style={{ marginLeft: '-10px', color: props.cor, fontSize: '' }}> </i> <span style={{ textTransform: '', fontWeight: 'bold' }}>{props.valor}</span> </>
            : <><i></i>{props.valor}</>
        }
    </>
}